export const socialsData = {
    github: 'https://github.com/KalashThakur',
    linkedIn: 'https://www.linkedin.com/in/kalash-thakur-596ab31aa/',
    twitter: 'https://twitter.com/KalashThakur08',
    medium: 'https://medium.com/@thakurkalash11',
    mail: 'thakurkalash11@gmail.com',
}